'use client';

import { useEffect, useState } from 'react';
import { Story } from '@/utils/types';
import StoryCard from '@/components/StoryCard';
import AdsterraBanner from '@/components/AdsterraBanner';
import { Search } from 'lucide-react';

interface StoriesGridProps {
  stories: Story[];
  title: string;
  description?: string;
}

export default function StoriesGrid({
  stories,
  title,
  description,
}: StoriesGridProps) {
  const [filteredStories, setFilteredStories] = useState<Story[]>(stories);
  const [searchQuery, setSearchQuery] = useState('');

  useEffect(() => {
    if (searchQuery.trim() === '') {
      setFilteredStories(stories);
    } else {
      const query = searchQuery.toLowerCase();
      const filtered = stories.filter(
        (story) =>
          story.title.toLowerCase().includes(query) ||
          story.author.toLowerCase().includes(query) ||
          story.genre.toLowerCase().includes(query) ||
          story.description.toLowerCase().includes(query)
      );
      setFilteredStories(filtered);
    }
  }, [searchQuery, stories]);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 pb-16">
      <div className="mb-8">
        <h1 className="text-3xl sm:text-4xl font-bold text-foreground mb-2">
          {title}
        </h1>
        {description && (
          <p className="text-muted mb-6">{description}</p>
        )}

        {/* <div className="relative max-w-2xl">
          <Search className="absolute left-4 top-1/2 -translate-y-1/2
            w-5 h-5 text-muted" />
          <input
            type="text"
            placeholder="Search by title, character, world..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="w-full pl-12 pr-4 py-3 bg-card-bg border
              border-border rounded-xl text-foreground
              placeholder:text-muted focus:outline-none focus:ring-2
              focus:ring-primary focus:border-transparent transition-all"
          />
          {searchQuery && (
            <button
              onClick={() => setSearchQuery('')}
              className="absolute right-4 top-1/2 -translate-y-1/2
                text-muted hover:text-foreground transition-colors"
            >
              ✕
            </button>
          )}
        </div> */}
      </div>

      {filteredStories.length === 0 ? (
        <div className="text-center py-12">
          <p className="text-lg text-muted">
            No stories found matching "{searchQuery}"
          </p>
        </div>
      ) : (
        <>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3
            xl:grid-cols-4 gap-4 sm:gap-5">
            {filteredStories.map((story, index) => (
              <div key={story._id}>
                {index === 4 && <AdsterraBanner position="middle" />}
                <StoryCard story={story} />
              </div>
            ))}
          </div>
          <AdsterraBanner position="bottom" />
        </>
      )}
    </div>
  );
}
